import * as PIXI from 'pixi.js';

/**
 * Moves a PixiJS container to a new parent container while keeping its global position unchanged.
 * @param {PIXI.Container} newParent - The new parent container to which the object will be added.
 */
export function moveObjectToNewParent(object: PIXI.Container, newParent: PIXI.Container): void {
    // Ensure the object and newParent are valid
    if (!object || !newParent) {
        console.error('Invalid object or new parent container.');
        return;
    }

    // Step 1: Calculate the world position of the container
    const worldPosition = object.toGlobal(new PIXI.Point());

    // Step 2: Remove the container from its current parent and add it to the new parent
    if (object.parent) {
        object.parent.removeChild(object);
    }
    newParent.addChild(object);

    // Step 3: Recalculate the local position relative to the new parent
    const localPosition = newParent.toLocal(worldPosition);

    // Set the container's position to the calculated local position
    object.position.set(localPosition.x, localPosition.y);
}


export function delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
}
